import { combineReducers, Reducer, AnyAction } from "@reduxjs/toolkit";

import reducerCustomerList from "./reducers/customersList";
import reducerUserrList from "./reducers/usersList";
import reducerRoles from "./reducers/roles";

interface UnloadingsReducers {
  customerList: Reducer<any, AnyAction>;
  usersList: Reducer<any, AnyAction>;
  roles: Reducer<any, AnyAction>;
}

const RolesStore = combineReducers<UnloadingsReducers>({
  roles: reducerRoles,
  customerList: reducerCustomerList,
  usersList: reducerUserrList,

});

export default RolesStore;
